import { gql } from '@apollo/client';
import { useFetchCallback } from './useFetchCallback';

const GET_CLIENT_INVESTMENTS_PORTFOLIO_QUERY = gql`
  query GetClientInvestmentsPortfolios {
    getClientInvestmentsPortfolios {
      id
      account
      marketValue
    }
  }
`;

const GET_CLIENT_INVESTMENTS_PORTFOLIO_BACKUP = gql`
  query GetClientInvestmentsPBackup {
    getClientInvestmentsPBackup {
      id
      account
      marketValue
    }
  }
`;

export const useGetClientInvestmentsPortfolioWithFallback = () => {
  return useFetchCallback(
    GET_CLIENT_INVESTMENTS_PORTFOLIO_QUERY,
    GET_CLIENT_INVESTMENTS_PORTFOLIO_BACKUP,
    { fetchPolicy: 'no-cache' },
  );
};

//export default () => useQuery(GET_CLIENT_INVESTMENTS_PORTFOLIO_QUERY, { fetchPolicy: 'no-cache' });
